import React from 'react'
import PropTypes from 'prop-types'
import BlockUi from 'react-block-ui'
import withLayout from '../../../layout/withLayout'
import { lifecycle } from 'recompose'
import { getUIDefinitionByTaskName } from '../../ui-definition/ui-definition'
import ContentBox from '../../../layout/component/ContentBox'
import { NAME_COMPONENT_MAPPING } from './name-component-mapping'

const componentNotDefined = (componentName) => () => {
    return (
        <ContentBox title={componentName}>
            <h1>Not defined</h1>
        </ContentBox>
    )
}

const getComponentForName = (componentName) => {
    const component = NAME_COMPONENT_MAPPING[componentName]
    return component || componentNotDefined(componentName)
}


const TaskDetail = (props) => {
    const { task, taskName, taskReadOnly, noFollowUp, fetching } = props
    if (noFollowUp) {
        return (<ContentBox title="No follow up task" />)
    }
    if (!task) {
        return null
    }

    const { widgetList } = getUIDefinitionByTaskName(taskName)

    return (
        <BlockUi tag="div" blocking={fetching}>
            {
                widgetList.map((widget, index) => {
                    let { component, readOnly, widgetProps = {} } = widget
                    const Component = getComponentForName(component)
                    readOnly = readOnly || taskReadOnly
                    return (
                        <Component
                            key={index}
                            readOnly={!!readOnly}
                            taskReadOnly={taskReadOnly}
                            {...widgetProps}
                            {...props} />
                    )
                })
            }
        </BlockUi>
    )
}

TaskDetail.propTypes = {
    task: PropTypes.object,
    taskName: PropTypes.string,
}


export default lifecycle({
    componentDidUpdate (prevProps) {
        if (!!prevProps && prevProps.taskName !== this.props.taskName) {
            window.scrollTo({
                top: 0,
                left: 0,
            })
        }
    },
    componentDidMount () {
        if (this.props.taskId) {
            this.props.findTaskDetail(this.props.taskId)
        }
        if (this.props.processInstanceId) {
            this.props.findTaskDetailByProcessInstanceId(this.props.processInstanceId)
        }
    },
})(withLayout(TaskDetail))



// WEBPACK FOOTER //
// ./src/modules/process/component/task-detail/TaskDetail.js